const isLocal = window.location.hostname === "localhost";

export const BASE_URL = isLocal
    ? "http://localhost:30021"
    : "https://smsearch.co.kr/api";
